<template>
     <!-- 选择结算申请单号、发票标签弹窗 -->
     <el-dialog
            :title="title"
            width="300px"
            :visible.sync="visible"
            @close="handleClose"
            custom-class="addInvoiceDialog"
            :append-to-body="true"
            :modal-append-to-body="false"
            :close-on-click-modal="false"
            >
            <el-form ref='addInvoiceForm' :model="addInvoiceForm" >
                <el-form-item v-if="type === 'list'" label="申请单号" prop="SQYSQD" :rules="[{required:true,message:' ',trigger:'change'}]">
                    <el-select v-model="addInvoiceForm.SQYSQD" placeholder="请选择">
                        <el-option
                            v-for="(item,index) in SQYSQDOptions"
                            :key="index"
                            :label="item.label"
                            :value="item.value"
                        ></el-option>
                    </el-select>
                    </el-form-item>
                <el-form-item label="发票标签" prop="invoiceLabel" :rules="[{required:true,message:' ',trigger:'change'}]">
                    <el-select v-model="addInvoiceForm.invoiceLabel" placeholder="请选择">
                        <el-option
                            v-for="(item,index) in invoiceLabelOptions"
                            :key="index"
                            :label="item.label"
                            :value="item.value"
                        ></el-option>
                    </el-select>
                    </el-form-item>
                </el-form>
                <span slot="footer" class="dialog-footer">
                <el-button @click="handleAddInvoCancel">取消</el-button>
                <el-button type="primary" :loading="btnLoading" @click="handleAddInvoConfirm">确定</el-button>
            </span>
        </el-dialog>
</template>
<script>
import { getDictAndOptions } from '@/modules/transport/bms/api/common.js';
export default {
    name: 'AddInvoiceDialog',
    props: {
        title: {
            type: String,
            default: '新增发票'
        },
        openDialog: {
            type: Boolean,
            default: false
        },
        loading: {
            type: Boolean,
            default: false
        },
        type: {
            type: String,
            default: 'detail' // list / detail
        }
    },
    computed: {
        visible: {
            get() {
                return this.openDialog;
            },
            set(val) {
                this.$emit('update:openDialog', false);
            }
        },
        btnLoading: function() {
            return this.openDialog && this.loading;
        }
    },
    data() {
        return {
            addInvoiceForm: {
                SQYSQD: '',
                invoiceLabel: ''
            },
            SQYSQDOptions: [],
            invoiceLabelOptions: []
        };
    },
    methods: {
        // 新增确认
        handleAddInvoConfirm() {
            this.$refs.addInvoiceForm.validate((valid) => {
                if (valid) {
                    const offDialog = () => {
                        this.visible = false;
                    };
                    this.$emit('afterConfirm', this.addInvoiceForm, offDialog);
                }
            });
        },
        // 新增取消
        handleAddInvoCancel() {
            this.visible = false;
        },
        handleClose() {
            this.$refs['addInvoiceForm'].clearValidate();
            this.$refs['addInvoiceForm'].resetFields();
        }
    },
    async created() {
        const { BMS_AP_INVOICE_LABEL_OPTIONS } = await getDictAndOptions('BMS_AP_INVOICE_LABEL');
        this.invoiceLabelOptions = BMS_AP_INVOICE_LABEL_OPTIONS;
    }
};
</script>
